import { render, staticRenderFns } from "./postsbooths.vue?vue&type=template&id=28cad746&"
import script from "./postsbooths.vue?vue&type=script&lang=js&"
export * from "./postsbooths.vue?vue&type=script&lang=js&"
import style0 from "./postsbooths.vue?vue&type=style&index=0&id=28cad746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports